<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <ul>
      <li v-for="(question,index) in questions" :key="index">
        <div class="stem">{{ question.id }}. {{ question.stem }}</div>
        <div class="option">
          <label v-for="(option,key) in JSON.parse(question.options)" :key="key">
            <input type="checkbox" :value="key" v-model="answers[index]">
            {{ key }}. {{ option }}
          </label>
        </div>
        <div class="answer">
          <button type="button" @click="check(index)">查看答案</button>
          <div :class="{active:isActive[index]}">
            <span v-html="judge(index)"></span>
            <span>正确答案：</span>{{ question.answer }}。<span>解析：</span>{{ question.note }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Questions',
  props: {
    msg: String
  },
  data() {
    return {
      questions: null,
      answers: [[]],
      isActive: [],
    }
  },
  mounted() {
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    let that = this;
    axios
        .get('data.json')
        .then(function (response) {
          that.questions = response.data
          that.answers = Array.from(Array(that.questions.length), () => new Array());
        });
  },
  methods: {
    check(index) {
      this.isActive[index] = true;
    },
    judge (index) {
      if (this.questions[index].answer == this.answers[index].sort().join('')) {
        return "<span style='color:green; font-weight: bolder'>回答正确。</span>";
      } else {
        return "<span style='color:red'>回答错误！</span>";
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
  line-height: 2rem;
}

li {
  width: 100%;
  text-align: left;
  margin-bottom: 1rem;
}

.stem {
  font-weight: bolder;
}

a {
  color: #42b983;
}

label {
  display: block;
}

.answer div {
  display: none;
}

.answer .active {
  display: block;
}
.wrong {
  color: red;
}
</style>
